module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-295.f9b3a68.woff2";